module.exports = __webpack_public_path__ + "static/media/chat.749c9bca.svg";